import { env } from '../../config/env';
import type { CartDto, UpdateCartItemRequest } from '../../types/api';
import * as http from './cartService.http';
import * as mock from './cartService.mock';

export interface CartService {
  fetchCart(): Promise<CartDto>;
  updateCart(items: UpdateCartItemRequest[]): Promise<CartDto>;
  clearCart(): Promise<void>;
}

const mockCartService: CartService = {
  fetchCart: mock.mockFetchCart,
  updateCart: (items) => mock.mockUpdateCart({ items }),
  clearCart: mock.mockClearCart,
};

const httpCartService: CartService = {
  fetchCart: http.httpFetchCart,
  updateCart: (items) => http.httpUpdateCart({ items }),
  clearCart: http.httpClearCart,
};

export const cartService: CartService = env.useMock ? mockCartService : httpCartService;
